import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllStocksStatsApi,
  GetBranchStocksStatsApi,
} from "../../ApiRequests";
import { ErrorToast } from "../../utils/ShowToast";

const branch = localStorage.getItem("branch");

export const fetchStockStats = createAsyncThunk(
  "fetch/StockStats",
  async () => {
    try {
      let response;
      if (branch) {
        response = await GetBranchStocksStatsApi(branch);
      } else {
        response = await GetAllStocksStatsApi();
      }
      return response.data.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const StockStatsSlice = createSlice({
  name: "StockStats",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStockStats.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchStockStats.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchStockStats.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default StockStatsSlice.reducer;
